import React from "react";
import AxiosClient from "../../_helpers/http.helper";
import urlHelper from "../../_helpers/url.format.server.helper";
import config from "../../config";


const CollectionContext = React.createContext();

export class CollectionProvider extends React.Component {
    state = {
        collection: {},
        bookBuildDetails: {},
        resourceData: [],
        resourceSharing: true,
        drvs: [],
        printAdminComponent: []
    };

    componentDidMount() {
        const collectionId = this.props.collectionId;
        this.loadInitialData(collectionId);
    }

    getBookBuildDetails = (collectionId) => {
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.getBookBuildContent,
            {
                collectionId: collectionId
            }
        );
        return AxiosClient.get(url);
    };

    getPrintAdminComponents = (collectionId) => {
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.getPrintAdminComponent,
            {
                collectionId: collectionId,
            }

        );
        AxiosClient.get(url)
            .then(response => {
                this.setState({printAdminComponent:response.data});
            });
    };

    loadBookBuildDetails = (collectionId) => {
        this.getBookBuildDetails(collectionId)
            .then(response => {
                this.setState({bookBuildDetails: response.data});
            }).catch(e => {
                console.log(e);
            });
    };

    loadCollectionDetails = (collectionId) => {
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.collectionById,
            {
                collectionId: collectionId
            }
        );
        return AxiosClient.get(url);
    };

    getDRVS = (collectionId) => {
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.getDRV,
            {
                collectionId: collectionId,
            }

        );
        AxiosClient.get(url)
            .then(response => {
                this.setState({drvs:response.data});
            });
    }

    loadInitialData = (collectionId) => {
        this.loadCollectionDetails(collectionId)
            .then((response) => {
                this.setState({collection: response.data});
                return response.data;
            })
            .then((response) => {

                const idList = response.resourceIds;

                const rebuildUrl = urlHelper.formatUrl(
                    config.contentService.baseUrl,
                    config.contentService.routes.getResourcesByIds,
                    {
                        queryParams:{
                            priceType: response.collectionType,
                            currency: response.geo.code,
                            fetchLinks: response.fetchLinks || false,
                            validateRights: response.validateRights || false
                        }

                    }

                );

                AxiosClient.post(rebuildUrl,idList)
                    .then(response => {
                        if(response.data.find(item => item.sharing === "Private")){
                            this.setState({
                                resourceSharing: false
                            });
                        }
                        this.setState({resourceData:response.data});
                    });

            })

            .catch(e => {
                console.log(e);
            });

        this.getBookBuildDetails(collectionId)
            .then(response => {
                this.setState({bookBuildDetails: response.data});
            }).catch(e => {
                console.log(e);
            });

        this.getDRVS(collectionId);
        this.getPrintAdminComponents(collectionId);
    };

    updateCollection = (field, value) => {
        this.setState({
            collection: {
                ...this.state.collection,
                [field]: value
            }
        });
    };

    updateBookBuildDetails = (field, value) => {
        this.setState({
            bookBuildDetails: {
                ...this.state.bookBuildDetails,
                [field]: value
            }
        });
    };
    render() {
        return (
            <CollectionContext.Provider value={{
                ...this.state,
                loadInitialData: this.loadInitialData,
                updateCollection: this.updateCollection,
                updateBookBuildDetails: this.updateBookBuildDetails,
                loadBookBuildDetails : this.loadBookBuildDetails,
                getDRVS: this.getDRVS
            }
            }>
                {this.props.children}
            </CollectionContext.Provider>
        );
    }
}

export const CollectionConsumer = CollectionContext.Consumer;



// WEBPACK FOOTER //
// ./src/components/context/CollectionContext.js